module.exports = __webpack_public_path__ + "static/media/drafts.1cd86fb1.png";